// Exporting components
export { FilesHubFilterPillContainer, Pill } from './components/FilesHubFilterPillContainer';
